export default "__VITE_ASSET__Bpf79Ox$__"